import React from "react";
import { StyledPagination } from "./index.styled";

type AppPaginationProps = {
  count: number;
  page: number;
  onChange: (page: number, perPage: number) => void;
  className?: string;
  perPage?: number;
  rowsPerPageOptions?: number[];
  itemRender?: (
    page: number,
    type: "page" | "prev" | "next" | "jump-prev" | "jump-next",
    originalElement: React.ReactNode,
  ) => React.ReactNode;
  showSizeChanger?: boolean;

  [x: string]: unknown;
};

const AppPagination: React.FC<AppPaginationProps> = ({
  count,
  page,
  onChange,
  className = "",
  perPage = 10,
  rowsPerPageOptions = [10, 15, 20, 50],
  itemRender = (_page, type, originalElement) => {
    if (type === "prev") {
      return <a>{"<"}</a>;
    }
    if (type === "next") {
      return <a>{">"}</a>;
    }
    return originalElement;
  },
  showSizeChanger = true,
  ...restProps
}) => {
  return (
    <StyledPagination
      total={count}
      current={page}
      pageSize={perPage}
      className={className}
      onChange={onChange}
      itemRender={itemRender}
      pageSizeOptions={rowsPerPageOptions}
      showSizeChanger={showSizeChanger}
      {...restProps}
    />
  );
};

export default AppPagination;
